'use client'

import type React from 'react'
import { useEffect, useState } from 'react'

export const DraftModeIndicator: React.FC = () => {
  const [show, setShow] = useState(true)

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), 10000) // Auto-hide after 10 seconds
    return () => clearTimeout(timer)
  }, [])

  if (!show) {
    return (
      <button
        onClick={() => setShow(true)}
        className="fixed bottom-4 right-4 bg-yellow-500 text-white px-3 py-2 rounded-full shadow-lg hover:bg-yellow-600 transition-all z-50 text-xs"
        aria-label="Show draft mode info"
        type="button"
      >
        📝
      </button>
    )
  }

  return (
    <div className="fixed bottom-4 right-4 bg-yellow-500 text-white px-4 py-3 rounded-lg shadow-lg z-50 max-w-sm">
      <div className="flex items-start gap-3">
        <span className="text-2xl">📝</span>
        <div className="flex-1">
          <h3 className="font-bold text-sm mb-1">Draft Mode Active</h3>
          <p className="text-xs mb-2">
            You're viewing unpublished changes. Cookie expires in 1 hour.
          </p>
          <div className="flex gap-2">
            <a
              href="/next/exit-preview"
              className="text-xs bg-white text-yellow-600 px-2 py-1 rounded hover:bg-gray-100 transition-colors"
            >
              Exit Draft Mode
            </a>
            <button
              onClick={() => setShow(false)}
              className="text-xs bg-yellow-600 px-2 py-1 rounded hover:bg-yellow-700 transition-colors"
              type="button"
            >
              Minimize
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
